export var SelectionType;
(function (SelectionType) {
    SelectionType["TEXT"] = "text";
    SelectionType["COLOR"] = "color";
    SelectionType["IMAGE"] = "image";
})(SelectionType || (SelectionType = {}));
